/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface CreditsChangeSummary
 */
export interface CreditsChangeSummary {
    /**
     * 
     * @type {number}
     * @memberof CreditsChangeSummary
     */
    balance_diff: number;
    /**
     * 
     * @type {number}
     * @memberof CreditsChangeSummary
     */
    balance_now: number;
    /**
     * 
     * @type {string}
     * @memberof CreditsChangeSummary
     */
    cause?: CreditsChangeSummaryCauseEnum;
}




/**
* @export
* @enum {string}
*/
export enum CreditsChangeSummaryCauseEnum {
    ADDEDINITIAL = 'ADDED_INITIAL',
    ADDEDBYPURCHASE = 'ADDED_BY_PURCHASE',
    ADDEDMANUALLY = 'ADDED_MANUALLY',
    SPENTFORFFREQUEST = 'SPENT_FOR_FFREQUEST',
    REIMBURSEDFFREQUEST = 'REIMBURSED_FFREQUEST',
    ADDEDFORTESTING = 'ADDED_FOR_TESTING',
    SPENTFORTESTING = 'SPENT_FOR_TESTING'
}


